/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_User_Password_ErrorInputs */

const vi_toast_user_password_error = /** @type {(inputs: Toast_User_Password_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi mật khẩu thất bại`)
};

/**

* @param {Toast_User_Password_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_user_password_error = /** @type {((inputs?: Toast_User_Password_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_User_Password_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_user_password_error(inputs)
});